module.exports = __webpack_public_path__ + "Icono_Cervical-Bco_126px.png";